import { v4 as uuidv4 } from 'uuid';
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Slider, useTheme } from "@mui/material";

import './mobile.controller.scss';
import VolumeUp from '@mui/icons-material/VolumeUp';
import OpacityIcon from '@mui/icons-material/Opacity';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import CloseIcon from '@mui/icons-material/Close';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import FolderDeleteIcon from '@mui/icons-material/FolderDelete';
import BorderColorIcon from '@mui/icons-material/BorderColor'
import ZoomOutMapOutlinedIcon from '@mui/icons-material/ZoomOutMapOutlined';


import { changeZeroSecond, copyObject, linkactive } from '../commonFunction';
import { getSelectedType, getNextZIndex } from '../commonFunction';
import { ProjectJSON_Store, thumbNails_Store, StretchScreenFlag_store } from '../../../store/actions/projectdata';
import { SelectedItemID_Store, VideoElements_Store, audioElements_Store, imageElements_Store, selectedGroupID_Store } from '../../../store/actions/webgldata';
import { removeElements, duplicateElementCreate, splitElementCreate, fullVideoSize, checkVolumeValue } from './controlCommonFunc';

export const MobileControl = () => {
  const dispatch = useDispatch();
  const ProjectData = useSelector(store => store.projectdata.projectJSON);
  const selectedID = useSelector(store => store.webgldata.selectedItemID);
  const Time_Count = useSelector((store) => store.videodata.Time_Count);
  const videoElements = useSelector(store => store.webgldata.videoElements);
  const audioElements = useSelector(store => store.webgldata.audioElements);
  const imageElements = useSelector(store => store.webgldata.imageElements);
  const selectedGroupID = useSelector(store => store.webgldata.selectedGroupID);
  const thumbNails = useSelector(store => store.projectdata.thumbNails);
  const stretchScreenFlag = useSelector((store) => store.projectdata.stretchScreenFlag);
  const selectedIDs = useMemo(() => (
    Array.isArray(selectedID)
      ? selectedID.filter(Boolean)
      : selectedID ? [selectedID] : []
  ), [selectedID]);
  const isMultiSelection = selectedIDs.length > 1;
  const primarySelectedID = selectedIDs.length === 1 ? selectedIDs[0] : null;
  const selectedEntries = useMemo(() => selectedIDs.map((id) => {
    if (!ProjectData?.videos) return null;
    const type = getSelectedType(id, ProjectData);
    return type && ProjectData?.[type]?.[id]
      ? { id, type, item: ProjectData[type][id] }
      : null;
  }).filter(Boolean), [selectedIDs, ProjectData]);
  const supportsVolume = selectedEntries.length === selectedIDs.length
    && selectedEntries.length > 0
    && selectedEntries.every(({ type }) => type === 'videos' || type === 'audios');
  const supportsOpacity = selectedEntries.length === selectedIDs.length
    && selectedEntries.length > 0
    && selectedEntries.every(({ type }) => type === 'videos' || type === 'images' || type === 'text');


  const [menuOpen, setMenuOpen] = useState(false);
  const [activeAdjustment, setActiveAdjustment] = useState(null);
  const sheetRef = useRef(null);
  const sheetDragStartRef = useRef(null);
  const [hoverItem, setHoverItem] = useState(-1);
  const onTouchStart = (index) => { setHoverItem(index); }
  const onTouchEnd = () => { setTimeout(() => { setHoverItem(-1); }, 100); }

  const onSheetPointerDown = (event) => {
    if (event.target.closest('button')) return;
    sheetDragStartRef.current = event.clientY;
    event.currentTarget.setPointerCapture?.(event.pointerId);
  }

  const onSheetPointerMove = (event) => {
    if (sheetDragStartRef.current === null || !sheetRef.current) return;
    const distance = Math.max(0, event.clientY - sheetDragStartRef.current);
    sheetRef.current.style.transform = `translateY(${distance}px)`;
  }

  const onSheetPointerEnd = (event) => {
    if (sheetDragStartRef.current === null) return;
    const endY = Number.isFinite(event.clientY) ? event.clientY : sheetDragStartRef.current;
    const distance = Math.max(0, endY - sheetDragStartRef.current);
    sheetDragStartRef.current = null;
    if (sheetRef.current) sheetRef.current.style.transform = '';
    if (distance > 72) setMenuOpen(false);
  }

  const levelUpClick = () => { levelUpDown(1); }
  const replitClick = () => { splitFunction(); }
  const volumeClick = () => { openVolumnMenu(); }
  const levelDownClick = () => { levelUpDown(-1); }
  const removeClick = () => { removeElementFunc(); }
  const duplicateClick = () => { duplicateFunction(); }
  const opacityClick = () => {
    setActiveAdjustment((current) => current === 'opacity' ? null : 'opacity');
  }

  const theme = useTheme();
  const menuInfo = [
    {
      icon: <ContentCopyIcon />,
      title: 'Duplicate',
      default: false,
      func: duplicateClick
    },{
      icon: <ContentCutIcon />,
      title: 'Split',
      default: false,
      func: replitClick
    },  {
      icon: <DeleteOutlineIcon />,
      title: 'Delete',
      default: false,
      func: removeClick
    }, {
      title: 'Layer',
      default: false,
      icon:
        <ArrowUpwardOutlinedIcon
          onClick={levelUpClick}
          className='w-40 h-40 text-[#9094a3] p-[8px]'
        />,
      icon1:
        <ArrowDownwardOutlinedIcon
          onClick={levelDownClick}
          className='w-40 h-40 text-[#9094a3] p-[8px]'
        />,
    }, {
      icon: <VolumeUp />,
      title: 'Volume',
      default: false,
      func: volumeClick,
    }, {
      icon: <OpacityIcon />,
      title: 'Opacity',
      default: false,
      func: opacityClick,
    }, 
    // {
    //   icon: <AutoFixHighIcon />,
    //   title: 'EditSubtitle',
    //   default: false,
    //   func: editSubtitleClick,
    // },
  ];

  const [activeType, setActiveType] = useState('')
  const [activevideo, setActiveVideo] = useState(null)

  useEffect(() => {
    let tempType = ''
    let activeVideo = null

    if (primarySelectedID && ProjectData) {
      tempType = getSelectedType(primarySelectedID, ProjectData);
    } else if (isMultiSelection) {
      tempType = 'multiple';
    }

    if (tempType === 'videos') {
      activeVideo = ProjectData.videos[primarySelectedID]
    }

    setActiveVideo(activeVideo)

    if (tempType !== activeType) {
      setActiveType(tempType)
    }
  }, [primarySelectedID, isMultiSelection, ProjectData, activeType])

  const removeElementFunc = async () => {
    const result = await removeElements(ProjectData, selectedIDs);
    if (!result) return;
    const [newJSONdata, deletedItems] = result;

    if (!!newJSONdata) {
      dispatch(SelectedItemID_Store(null));
      dispatch(ProjectJSON_Store(newJSONdata, {
        label: deletedItems.length > 1 ? 'Delete selected clips' : 'Delete clip',
      }));
      deletedItems.forEach((item) => changeZeroSecond(item, dispatch));
    }
  }

  const splitFunction = async () => {
    if (!primarySelectedID) return;
    const newUUID = uuidv4();
    const [newJSONdata, type] = await splitElementCreate(ProjectData, primarySelectedID, newUUID, Time_Count);
    if (!newJSONdata) return;

    if (type === 'videos') {
      if (!videoElements[primarySelectedID]) return;
      let newVideoEL = videoElements[primarySelectedID].cloneNode(true);
      newVideoEL.id = newUUID;

      dispatch(VideoElements_Store({
        ...videoElements,
        [newUUID]: newVideoEL
      }))

      if (thumbNails[primarySelectedID]) {
        dispatch(thumbNails_Store({
          ...thumbNails,
          [newUUID]: thumbNails[primarySelectedID]
        }))
      }
    }

    if (type === 'audios') {
      if (!audioElements[primarySelectedID]) return;
      let newAudioEl = audioElements[primarySelectedID].cloneNode(true);
      newAudioEl.id = newUUID;

      dispatch(audioElements_Store({ ...audioElements, [newUUID]: newAudioEl }))
    }

    if (type === 'images') {
      if (!imageElements[primarySelectedID]) return;
      let newImageEL = imageElements[primarySelectedID].cloneNode(true);
      newImageEL.id = newUUID;

      let tempImageEL = Object.assign({}, imageElements);
      tempImageEL[newUUID] = newImageEL;
      await dispatch(imageElements_Store(tempImageEL));
    }

    dispatch(ProjectJSON_Store(newJSONdata));
  }

  const duplicateFunction = async () => {
    if (!primarySelectedID) return;
    const newUUID = uuidv4();
    const [newJSONdata, type] = await duplicateElementCreate(ProjectData, primarySelectedID, newUUID);
    if (!newJSONdata) return;

    if (type === 'videos') {
      if (!videoElements[primarySelectedID]) return;
      let newVideoEL = videoElements[primarySelectedID].cloneNode(true);
      newVideoEL.id = newUUID;

      dispatch(VideoElements_Store({
        ...videoElements,
        [newUUID]: newVideoEL
      }))

      if (thumbNails[primarySelectedID]) {
        dispatch(thumbNails_Store({
          ...thumbNails,
          [newUUID]: thumbNails[primarySelectedID]
        }))
      }
    }

    if (type === 'audios') {
      if (!audioElements[primarySelectedID]) return;
      let newAudioEl = audioElements[primarySelectedID].cloneNode(true);
      newAudioEl.id = newUUID;

      dispatch(audioElements_Store({ ...audioElements, [newUUID]: newAudioEl }))
    }

    if (type === 'images') {
      if (!imageElements[primarySelectedID]) return;
      let newImageEL = imageElements[primarySelectedID].cloneNode(true);
      newImageEL.id = newUUID;

      let tempImageEL = Object.assign({}, imageElements);
      tempImageEL[newUUID] = newImageEL;
      await dispatch(imageElements_Store(tempImageEL));
    }

    dispatch(ProjectJSON_Store(newJSONdata));
  }

  const levelUpDown = (flag) => {
    if (!primarySelectedID) return;
    if (flag !== 1 && flag !== -1) return;

    let tempJSON = JSON.parse(JSON.stringify(ProjectData));
    let type = getSelectedType(primarySelectedID, tempJSON);
    if (!type || !tempJSON[type][primarySelectedID]) return;

    let elementOb = tempJSON[type][primarySelectedID];
    let zIndex = getNextZIndex(tempJSON, primarySelectedID, type, flag)
    let currentIndex = elementOb.coordinate.zIndex;
    if (currentIndex === zIndex) return;

    elementOb.coordinate.zIndex = zIndex;
    dispatch(ProjectJSON_Store(tempJSON));
    changeZeroSecond(elementOb, dispatch)
  }

  // video volume change func start
  const [volumeValue, setVolumeValue] = useState(0);

  useEffect(() => {
    if (!supportsVolume) {
      setVolumeValue(0);
      return;
    }
    setVolumeValue(checkVolumeValue(selectedEntries[0].item.volume));
  }, [supportsVolume, selectedEntries])

  const openVolumnMenu = async () => {
    if (supportsVolume) {
      setActiveAdjustment((current) => current === 'volume' ? null : 'volume');
    } else {
      window.toastr.error('could you please select Video Item?');
      setActiveAdjustment(null);
    }
  }

  const changedVolume = async (nextVolume = volumeValue) => {
    if (supportsVolume) {
      const newJSONdata = copyObject(ProjectData);
      selectedEntries.forEach(({ id, type }) => {
        newJSONdata[type][id].volume = Number(nextVolume);
      });
      dispatch(ProjectJSON_Store(newJSONdata, {
        label: 'Change volume',
        mergeKey: `volume:${selectedIDs.slice().sort().join(',')}`,
      }));
    }
  }
  // video volume change func end

  // opacity change func start
  const [opacity, setOpacity] = useState(0);
  const [selected, setSelected] = useState({})

  useEffect(() => {
    let tempSelected = {}
    if (supportsOpacity) {
      const tempItem = selectedEntries[0].item;
      tempSelected = { ...tempItem, alpha: tempItem.alpha ?? 1 };
      const alpha = Number(tempItem.alpha);
      setOpacity(Number.isFinite(alpha) ? alpha : 1);
    } else {
      setOpacity(0);
    }

    setSelected(tempSelected)
  }, [supportsOpacity, selectedEntries])

  useEffect(() => {
    if (activeAdjustment === 'volume' && !supportsVolume) {
      setActiveAdjustment(null);
    }
    if (activeAdjustment === 'opacity' && !supportsOpacity) {
      setActiveAdjustment(null);
    }
  }, [activeAdjustment, supportsVolume, supportsOpacity]);

  const changedOpacity = async (nextOpacity = opacity) => {
    let tempJSON = copyObject(ProjectData);
    if (!supportsOpacity) {
      setOpacity(1);
      return;
    }
    const alpha = Number(nextOpacity);
    const nextAlpha = Number.isFinite(alpha) ? Math.min(1, Math.max(0, alpha)) : 1;
    setOpacity(nextAlpha);
    const changedItems = selectedEntries.map(({ id, type }) => {
      const element = tempJSON[type][id];
      element.alpha = nextAlpha;
      return element;
    });
    if (changedItems.length) {
      dispatch(ProjectJSON_Store(tempJSON, {
        label: 'Change opacity',
        mergeKey: `opacity:${selectedIDs.slice().sort().join(',')}`,
      }));
      changedItems.forEach((item) => changeZeroSecond(item, dispatch));
    }
  }
  // opacity change func end

  const [selectedType, setSelectedType] = useState(false)
  useEffect(() => {
    let tempJSON = copyObject(ProjectData)
    let type = getSelectedType(primarySelectedID, tempJSON)
    setSelectedType(type === 'text')
  }, [ProjectData, primarySelectedID])

  const textEdit = () => {
    linkactive(9, 9, dispatch, false)
  }

  const changeDisable = () => {
    if (activeType !== 'videos') {
      return
    }

    let tempJSON = copyObject(ProjectData)
    let activeVideo = tempJSON.videos[primarySelectedID]

    if (!activeVideo) {
      return
    }

    activeVideo.disable_video = !activeVideo?.disable_video
    dispatch(ProjectJSON_Store(tempJSON))
    changeZeroSecond(activeVideo, dispatch)
  }

  const removeGroup = () => {
    if (!ProjectData?.videos || !selectedGroupID) {
      return
    }

    const tempJSON = copyObject(ProjectData)
    const videos = tempJSON.videos
    const audios = tempJSON.audios
    const images = tempJSON.images
    const texts = tempJSON.text

    const videoKeys = Object.keys(videos)
    const audiokeys = Object.keys(audios)
    const imageKeys = Object.keys(images)
    const textKeys = Object.keys(texts)

    const tempVideos = {}
    const tempAudios = {}
    const tempImages = {}
    const tempTexts = {}

    let removeObject = null

    videoKeys.forEach((key) => {
      const videoEl = videos[key]
      if (videoEl.groups !== selectedGroupID) {
        tempVideos[key] = videoEl
      } else if (videoEl.timeline_start === 0) {
        removeObject = videoEl
      }
    })

    audiokeys.forEach((key) => {
      const audioEl = audios[key]
      if (audioEl.groups !== selectedGroupID) {
        tempAudios[key] = audioEl
      } else if (audioEl.timeline_start === 0) {
        removeObject = audioEl
      }
    })

    imageKeys.forEach((key) => {
      const imageEl = images[key]
      if (imageEl.groups !== selectedGroupID) {
        tempImages[key] = imageEl
      } else if (imageEl.timeline_start === 0) {
        removeObject = imageEl
      }
    })

    textKeys.forEach((key) => {
      const textEl = texts[key]
      if (textEl.groups !== selectedGroupID) {
        tempTexts[key] = textEl
      } else if (textEl.timeline_start === 0) {
        removeObject = textEl
      }
    })

    let tempNewJson = {
      ...tempJSON,
      videos: tempVideos,
      audios: tempAudios,
      images: tempImages,
      text: tempTexts,
    }

    dispatch(SelectedItemID_Store(null))
    dispatch(selectedGroupID_Store(null))
    dispatch(ProjectJSON_Store(tempNewJson))

    if (!!removeObject) {
      changeZeroSecond(removeObject, dispatch)
    }
  }

  const stretchScreenVideo = async () => {
    if (!primarySelectedID) return;
    const [, type] = await fullVideoSize(ProjectData, primarySelectedID);
    if (type === 'videos' || type === 'images'){
      dispatch(StretchScreenFlag_store(!stretchScreenFlag))
    }
  }

  return (
    <Box className={`mobile-controller-container ${!menuOpen ? 'desable-controller' : ''}`}>
      <Box component="button" type="button" aria-label={menuOpen ? 'Close clip controls' : 'Open clip controls'}
        className="menu-icon-btn" onClick={() => { setMenuOpen(!menuOpen) }}>
        <KeyboardArrowRightIcon className={menuOpen ? 'open-menu-btn' : ''} />
      </Box>

      <Box ref={sheetRef} className={`mobile-contraller-body`} sx={{backgroundColor: theme.palette.mode === 'dark'? '#191919' : '#FCFCFC'}}>
        <Box className="mobile-sheet-header"
          onPointerDown={onSheetPointerDown}
          onPointerMove={onSheetPointerMove}
          onPointerUp={onSheetPointerEnd}
          onPointerCancel={onSheetPointerEnd}
        >
          <DragHandleIcon aria-hidden="true" />
          <Typography component="h2">
            {isMultiSelection ? `${selectedIDs.length} clips selected` : 'Clip controls'}
          </Typography>
          <Box component="button" type="button" aria-label="Close clip controls" onClick={() => setMenuOpen(false)}>
            <CloseIcon />
          </Box>
        </Box>
        {!!selectedType && (
          <div className="mobile-menu-item-contain">
            <button type="button"
              className={`mobile-menu-item ${hoverItem === 12 && 'active-item'}`}
              onTouchStart={() => { onTouchStart(12) }}
              onTouchEnd={onTouchEnd}
              onClick={textEdit}
            >
              <BorderColorIcon />
              <Typography component="h2">Edit</Typography>
            </button>
          </div>
        )}

        {menuInfo.filter((item) => {
          if (isMultiSelection && !['Delete', 'Volume', 'Opacity'].includes(item.title)) return false;
          if (item.title === 'Volume') return supportsVolume;
          if (item.title === 'Opacity') return supportsOpacity;
          return true;
        }).map((item, index) =>
          <Box className="mobile-menu-item-contain" key={index}>
            {item.title !== 'Layer' && (
              <Box component="button" type="button" className={`mobile-menu-item ${hoverItem === index && 'active-item'}`}
                onTouchStart={() => { onTouchStart(index); }}
                onTouchEnd={onTouchEnd}
                onClick={item.func}
              >
                {item.icon}
                <Typography component="h2">{item.title}</Typography>
              </Box>
            )}

            {item.title === 'Layer' && (
              <div className='mobile-layer-control'>
                <div className='mobile-layer-buttons'>
                  <button type="button" aria-label="Bring forward" onClick={levelUpClick}><ArrowUpwardOutlinedIcon /></button>
                  <button type="button" aria-label="Send backward" onClick={levelDownClick}><ArrowDownwardOutlinedIcon /></button>
                </div>

                <Typography component="h2" sx={{fontSize: '0.7rem'}}>
                  Layer {selected?.coordinate?.zIndex + 9}
                </Typography>
              </div>
            )}
          </Box>
        )}

        {activeType === 'videos' && (
          <div className="mobile-menu-item-contain">
            <div onTouchEnd={onTouchEnd}
              onTouchStart={() => { onTouchStart(12) }}
              className={`mobile-menu-item ${hoverItem === 12 && 'active-item'}`}
            >
              <input type='checkbox'
                onChange={changeDisable}
                checked={!!activevideo?.disable_video}
                className='default-input flex-1'
              />

              <Typography component='h2'>Disable</Typography>
            </div>
          </div>
        )}

        {selectedGroupID && !isMultiSelection && (
          <>
          <div className="mobile-menu-item-contain">
            <button type="button" onTouchEnd={onTouchEnd}
              onTouchStart={() => { onTouchStart(12) }}
              className={`mobile-menu-item ${hoverItem === 12 && 'active-item'}`}
              onClick={removeGroup}
            >
              <FolderDeleteIcon />
              <Typography component='h2'>Delete track</Typography>
            </button>
          </div>
          <div className="mobile-menu-item-contain">
            <button type="button" onTouchEnd={onTouchEnd}
              onTouchStart={() => { onTouchStart(13) }}
              className={`mobile-menu-item ${hoverItem === 13 && 'active-item'}`}
              onClick={stretchScreenVideo}
            >
              <ZoomOutMapOutlinedIcon />
              <Typography component='h2'>Fit canvas</Typography>
            </button>
          </div>
          </>
          
        )}

        {activeAdjustment && (
          <Box className="mobile-adjustment-control">
            <Box className="mobile-adjustment-label">
              {activeAdjustment === 'volume' ? <VolumeUp /> : <OpacityIcon />}
              <Typography>{activeAdjustment === 'volume' ? 'Volume' : 'Opacity'}</Typography>
              <span>{Math.round((activeAdjustment === 'volume' ? volumeValue : opacity) * 100)}%</span>
            </Box>
            <Slider
              aria-label={activeAdjustment === 'volume' ? 'Volume' : 'Opacity'}
              value={activeAdjustment === 'volume' ? volumeValue : opacity}
              step={0.05}
              min={0}
              max={1}
              onChange={(event, value) => {
                if (activeAdjustment === 'volume') setVolumeValue(value);
                else setOpacity(value);
              }}
              onChangeCommitted={(event, value) => {
                if (activeAdjustment === 'volume') changedVolume(value);
                else changedOpacity(value);
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}
